import apiClient from '../../shared/api/apiClient'
import { ENDPOINTS } from '../../shared/api/endpoints'

export interface OrganizationProfile {
  id?: string
  name?: string
  schoolName?: string
  organizationName?: string
  orgName?: string
  title?: string
  email?: string
  primaryContactEmail?: string
  institutionalEmail?: string
  contactPhone?: string
  primaryContactPhone?: string
  phoneNumber?: string
  contactNumber?: string
  address?: string
  headOfficeAddress?: string
  physicalAddress?: string
  logoUrl?: string
  logo?: string
  logo_url?: string
  shortLivedLogoUrl?: string
  [key: string]: any
}

export const organizationApi = {
  /**
   * Get current organisation profile: GET /api/organization/me
   */
  async getMyOrganizationProfile(): Promise<OrganizationProfile> {
    try {
      const response = await apiClient.get<any>(ENDPOINTS.ORGANIZATION.ME)
      return response.data?.data || response.data || {}
    } catch {
      try {
        const res = await apiClient.get<any>(ENDPOINTS.SETTINGS)
        return res.data?.data || res.data || {}
      } catch {
        return {}
      }
    }
  },
}
